import { createSlice } from "@reduxjs/toolkit";

interface IToastNotification {
  id: string;
  onClose?: any;
  onOpen?: any;
  autoClose: number;
  title: string;
  message: string;
  color: string;
  className: string;
  style: any;
  show: boolean;
  type: string;
}

export const initialState: IToastNotification = {
  id: "",
  show: false,
  onClose: null,
  onOpen: null,
  autoClose: 9000,
  title: "",
  message: "",
  color: "",
  className: "",
  style: {},
  type: "",
};

const toastData = createSlice({
  name: "toastData",
  initialState: {} as IToastNotification,
  reducers: {
    openToast: (state, { payload }) => {
      state.id = payload.id;
      state.onClose = payload.onClose;
      state.onOpen = payload.onOpen;
      state.autoClose = payload.autoClose || 3000;
      state.title = payload.title;
      state.message = payload.message;
      state.color = payload.color;
      state.className = payload.className;
      state.style = payload.style;
      state.show = true;
      state.type = payload.type;
    },
    closeToast: (state) => {
      state.show = false;
    },
  },
});

export default toastData.reducer;
export const { openToast, closeToast } = toastData.actions;
